import {
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles({
  mensagem: {
    fontSize: '16px',
    lineHeight: '1.38',
    textAlign: 'center',
    color: '#5e6784',
    marginBottom: '24px',
  },
});

export default useStyles;
